import { RouterOptions } from 'vue-router'
import TranscoProviders from '@/pages/TranscoProviders.vue'
import TranscoProducts from '@/pages/TranscoProducts.vue'
import NotFoundPage from '@/pages/NotFoundPage.vue'

const routes: RouterOptions = {
  mode: 'history',
  routes: [
    {
      name: 'home',
      path: '/home',
      redirect: {
        name: 'transco-providers',
      },
    },
    {
      path: '',
      redirect: {
        name: 'transco-providers',
      },
    },
    {
      path: '/',
      redirect: {
        name: 'transco-providers',
      },
    },
    {
      name: 'transco-providers',
      path: '/transco-providers',
      component: TranscoProviders,
    },
    {
      name: 'transco-products',
      path: '/transco-products',
      component: TranscoProducts,
    },
    {
      name:   'not-found',
      path:   '/not-found',
      component: NotFoundPage,
    },
    {
      path:   '*',
      redirect: {
        name:   'not-found',
      },
    },
  ],
}

export default routes
